export default __webpack_public_path__ + "static/media/twitter-icon-square-rounded.5e042b77.svg";